import { Text } from "./Text.mjs";
import { useTheme } from "./ThemeProvider.mjs";
import { Flex } from "./Flex.mjs";
import { Icon } from "./Icon.mjs";
import { useStyles } from "purse-styles";
import React from "react";
import { jsx } from "react/jsx-runtime";

//#region src/Avatar.tsx
const AVATAR_SIZES = {
	xs: {
		size: 14,
		textSize: "xs",
		iconSize: "xs"
	},
	sm: {
		size: 16,
		textSize: "xs",
		iconSize: "sm"
	},
	md: {
		size: 18,
		textSize: "xs",
		iconSize: "md"
	},
	lg: {
		size: 22,
		textSize: "sm",
		iconSize: "lg"
	}
};
function getInitials(name) {
	return name.split(" ").map((part) => part.charAt(0).toUpperCase()).slice(0, 2).join("");
}
const Avatar = ({ size = "md", image, alt, name, showIcon = false }) => {
	const theme = useTheme();
	const config = AVATAR_SIZES[size];
	const containerStyles = useStyles({
		width: config.size,
		height: config.size,
		borderRadius: "50%",
		backgroundColor: theme.colors.sand5,
		overflow: "hidden",
		flexShrink: 0
	});
	const imageStyles = useStyles({
		width: "100%",
		height: "100%",
		objectFit: "cover"
	});
	if (image) return /* @__PURE__ */ jsx("div", {
		className: containerStyles,
		children: /* @__PURE__ */ jsx("img", {
			src: image,
			alt: alt || name || "Avatar",
			className: imageStyles,
			referrerPolicy: "no-referrer"
		})
	});
	if (name && !showIcon) {
		const initials = getInitials(name);
		return /* @__PURE__ */ jsx(Flex, {
			align: "center",
			justify: "center",
			className: containerStyles,
			style: { backgroundColor: theme.colors.sand6 },
			children: /* @__PURE__ */ jsx(Text, {
				size: config.textSize,
				weight: "medium",
				light: true,
				style: { fontSize: config.size * .45 },
				children: initials
			})
		});
	}
	return /* @__PURE__ */ jsx(Flex, {
		align: "center",
		justify: "center",
		className: containerStyles,
		children: /* @__PURE__ */ jsx(Icon, {
			name: "CircleUser",
			size: config.iconSize,
			color: "sand11"
		})
	});
};

//#endregion
export { Avatar };